import React, { useEffect } from "react";
import { MDBDataTableV5 } from "mdbreact";
import { Button, TableContainer } from "../../../styles";
import { ICON_BIN, ICON_PEN, ICON_PLUS } from "../../../utils/icons";
import DeleteModal from "../DeleteModal";
import { useState } from "react";
import AddInventory from "./AddInventory";
import EditInventory from "./EditInventory";
import { useAuthContext } from "../../../context/auth_context";
import { useInventoryContext } from "../../../context/inventory_context";
import MiniLoader from "../../../utils/MIniLoader";
import { useUserContext } from "../../../context/user_context";
import CustomTable from "../../../utils/CustomTable";


export default function AllInventory() {

      const [inventoryData, setInventoryData] = useState('');

      const {
            getFeature: { checkFeature }
      } = useAuthContext();


      const {
            openAddInventory,
            openEditInventory,
            inventoryLoading, getInventoryData, allInventory
      } = useInventoryContext();

      const { btoken, stoken } = useUserContext();


      function openEditModal(inventory) {
            setInventoryData(inventory);
            openEditInventory();
      }

      useEffect(() => {
            const inventory = allInventory?.map((item, i) => {

                  const { invtid, qty, cost_price, selling_price, itemName, qty_limit, unit, batchNo, expiry_date, timestamp } = item;

                  const payload = { btoken, stoken, invtid };

                  return (
                        {
                              sn: i + 1,
                              invtid,
                              timestamp,
                              itemName,
                              qty,
                              cost_price,
                              selling_price,
                              qty_limit,
                              unit,
                              batchNo,
                              expiry_date,

                              action:
                                    checkFeature('inventory_edit') &&
                                    <h6 className="d-flex fit-content  border-bottom pointer border-success green-text text-center"
                                          onClick={(e) => openEditModal(item)}
                                    >
                                          {ICON_PEN}
                                    </h6>
                              ,
                              delete:
                                    checkFeature('inventory_delete') &&
                                    <DeleteModal
                                          payload={payload}
                                          name={itemName}
                                          url={'deleteInventory'}
                                          getDataFn={getInventoryData}
                                          dataName={'Inventory'}
                                    >
                                          <h6 className="d-flex fit-content  border-bottom pointer border-danger red-text text-center"
                                          >
                                                {ICON_BIN}
                                          </h6>
                                    </DeleteModal>


                        }
                  );
            });

            setDatatable({
                  ...datatable,
                  // columns: [
                  //       {
                  //             label: checkFeature('inventory_edit') ? 'Action' : '',
                  //             label: 'Action',
                  //             field: "action",
                  //             width: 200,
                  //       },
                  //       {
                  //             label: checkFeature('inventory_delete') ? 'Delete' : '',
                  //             label: 'Delete',
                  //             field: "delete",
                  //             width: 200,
                  //       },
                  // ],
                  rows: inventory
            });
      }, [allInventory]);

      useEffect(() => {
            getInventoryData();
      }, []);


      const [datatable, setDatatable] = React.useState({
            columns: [
                  {
                        label: "S/N",
                        field: "sn",
                        width: 150,
                        attributes: {
                              "aria-controls": "DataTable",
                              "aria-label": "sn",
                        },
                  },
                  {
                        label: "ID",
                        field: "invtid",
                        width: 150,
                  },
                  {
                        label: "Date Added",
                        field: "timestamp",
                        width: 150,
                  },
                  {
                        label: "Item Name",
                        field: "itemName",
                        width: 270,
                  },
                  {
                        label: "Quantity",
                        field: "qty",
                        width: 270,
                  },
                  {
                        label: "Cost Price",
                        field: "cost_price",
                        width: 270,
                  },
                  {
                        label: "Selling Price",
                        field: "selling_price",
                        width: 270,
                  },
                  {
                        label: "Batch No",
                        field: "batchNo",
                        width: 270,
                  },
                  {
                        label: "Expiry Date",
                        field: "expiry_date",
                        width: 270,
                  },
                  {
                        label: checkFeature('inventory_edit') && 'Action',
                        field: "action",
                        width: 200,
                  },
                  {
                        label: checkFeature('inventory_delete') && 'Delete',
                        field: "delete",
                        width: 200,
                  },
            ],
            rows: []
      });


      return (
            <>

                  <div className="">

                        <CustomTable
                              tableTitle={"All Inventory"}
                              loading={inventoryLoading} getData={getInventoryData}
                              openAddModal={openAddInventory}
                              addTitle={"Add Inventory"}
                              datatable={datatable}
                        />

                  </div>

                  {/* Add Inventory Modal */}
                  <AddInventory />
                  {/* Add Inventory Modal */}

                  {/* Edit Inventory Modal */}
                  <EditInventory
                        {...inventoryData}
                  />
                  {/* Edit Inventory Modal */}
            </>

      );
}
